<template>
  <div class="bg-white rounded">
    <div class="block pb-2">
      <div class="flex items-start justify-between w-full mb-2">
        <div
          v-if="typeof item.todo === 'boolean'"
          @click.self="todochange()"
          class="pt-4 pr-2 pl-2">
          <input
            type="checkbox"
            :id="'i' + item.id"
            :checked="!item.todo"
            @click.self.stop
            @change.self="handleTodoChange(item)" />
        </div>

        <div class="flex-1 readonly pb- " style="">
          <note
            class="border border-white rounded"
            :text="noteText"
            :item="item"
            :strikethrough="item.todo === false"
          />
        </div>

      </div>

      <div class="flex justify-between items-center px-2" >
        <div>
          <!-- <div class="text-xs rounded-full bg-light-green border-t-2 border-light-green py-1 px-2" v-if="item.isPublic">Public</div> -->
        </div>

        <t-button
          inverted
          class="text-xs text-full-blue unselectable"
          @click="$emit('edit')">Edit</t-button>
      </div>
    </div>

    <div v-if="showUrls && !!item.urls && !!item.urls.length">
      <url-list :urls="item.urls" />
    </div>

  </div>
</template>
<script>
 import path from 'path';
 import {mapState, mapActions} from 'vuex';
 import eventBus from '@/eventBus';
  import UrlList from './UrlList';
 import TxList from './TxList';
 import Note from './Note';
 import BangList from './BangList';
 import FormulaList from './FormulaList';


 function emojiOverlay() {
   var query = new RegExp('[\u1000-\uffff]|[\ud000-\udfff]', 'gi');

   return {
     token: function(stream) {
       query.lastIndex = stream.pos;
       var match = query.exec(stream.string);
       if (match && match.index == stream.pos) {
         stream.pos += match[0].length || 1;
         return 'emoji';
       } else if (match) {
         stream.pos = match.index;
       } else {
         stream.skipToEnd();
       }
   }};
 }

 export default {
   props: {
     item: {
       type: Object,
       default: null
     },

     tabIndex: {
       type: Number,
       required: true,
     },

     relativePath: {
       type: String,
       default: '/'
     },
     showUrls: {
       type: Boolean,
       default: true
     }
   },

   components: {UrlList, TxList, BangList, Note, FormulaList},

   computed: {
     noteText () {
       const todoPrefix = typeof this.item.todo === 'boolean' ? this.item.todo ? 'TODO ' : 'DONE ' : '';

       const folders = this.item.parsed.folder || [];
       let displayPath = path.join('/', this.item.path);
       let relPath = path.join('/', this.relativePath);
       let lastIndex = 0;
       for (let i=0; i < folders.length; i++) {
         const pattern = new RegExp('^' + folders[i].value)

         if (pattern.test(displayPath) && pattern.test(relPath)) {
           displayPath = displayPath.replace(pattern, '');
           relPath = relPath.replace(pattern, '');
           lastIndex++;
         }
       }

       const pathPrefix = !!folders && !!folders.length ? folders.slice(lastIndex).map(f => f.text).join('') : '';

       return (pathPrefix + ' ' + todoPrefix + (this.item.text || '')).trim();
     }
   },

   methods: {
     ...mapActions(['updateRecord']),

     async handleTodoChange (item) {
       const prefix = item.todo ? 'DONE ' : 'TODO '

       const p = (item.parsed.folder || []).map(f => f.text).join('')
       const pathPrefix = p === '/' ? '' : p + ' '

       await this.updateRecord({
         id: item.id,
         text: pathPrefix + prefix + item.text,
         date: item.date,
         isPublic: item.isPublic
       });

       eventBus.$emit('record');
     },
   }
 }
</script>
<style>
 img.emoji {
   height: 1em;
   width: 1em;
   margin: 0 .05em 0 .1em;
   vertical-align: -0.1em;
 }

 
</style>
